/* global document */

import './SlideInOverlay.scss';

import template from './SlideInOverlay.vhtml';

export default {
	name: 'SlideInOverlay',
	template: template,
	props: {
		isOpen: {
			type: Boolean,
			default: true,
		},
		maxWidth: {
			type: String,
			default: '768px',
		}
	},
	computed: {
		hasFooter() {
			return !!this.$slots.footer;
		},
	},
	watch: {
		isOpen( value ) {
			if (value) {
				document.querySelector('html').classList.add('no-scroll');
			} else {
				document.querySelector('html').classList.remove('no-scroll');				
			}
		},
	},
};
